// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RobiTest 2.0 App Shell — primary scroll lives in .rt2-main */

.rt2-shell {
  display: grid;
  grid-template-columns: var(--rt-sidebar-collapsed) 1fr;
  grid-template-rows: var(--rt-topbar-h) minmax(0, 1fr);
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  background: var(--rt-bg);
  color: var(--rt-text);
  transition: grid-template-columns 180ms ease;
}

.rt2-shell--expanded {
  grid-template-columns: var(--rt-sidebar-w) 1fr;
}

.rt2-shell--collapsed {
  grid-template-columns: var(--rt-sidebar-collapsed) 1fr;
}

.rt2-sidebar-slot {
  grid-column: 1;
  grid-row: 2;
  min-height: 0;
  min-width: 0;
  height: 100%;
  z-index: 30;
  position: relative;
}

.rt2-sidebar-backdrop {
  display: none;
}

.rt2-topbar {
  grid-column: 1 / -1;
  grid-row: 1;
  height: var(--rt-topbar-h);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  background: var(--topbar-background, var(--rt-surface));
  border-bottom: 1px solid var(--rt-border);
  z-index: 40;
  backdrop-filter: blur(8px);
}

.rt2-topbar__brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
  text-decoration: none;
  color: var(--rt-text);
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: -0.02em;
}

.rt2-topbar__brand svg {
  color: var(--rt-primary);
}

.rt2-topbar__context {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.rt2-topbar__sep {
  width: 1px;
  height: 22px;
  background: var(--rt-border);
}

.rt2-context-select {
  position: relative;
}

.rt2-context-select__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 220px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-md);
  background: var(--rt-surface);
  color: var(--rt-text);
  font-size: var(--rt-text-sm);
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.rt2-context-select__btn:hover {
  border-color: var(--rt-primary-border);
  background: var(--rt-primary-subtle);
}

.rt2-context-select__label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-text-muted);
  font-weight: 600;
}

.rt2-context-select__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}

.rt2-context-select__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  min-width: 280px;
  max-width: min(420px, 90vw);
  max-height: min(480px, 70vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: 50;
  padding: 6px;
}

.rt2-context-select__list {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  max-height: min(380px, 55vh);
}

.rt2-context-select__footer {
  flex: 0 0 auto;
  padding: 6px 10px 2px;
  font-size: 11px;
  color: var(--rt-text-muted, var(--text-secondary, #64748b));
  border-top: 1px solid var(--rt-border);
  margin-top: 4px;
}

.rt2-context-select__search {
  width: 100%;
  height: 32px;
  margin-bottom: 6px;
  padding: 0 10px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-md);
  font-size: var(--rt-text-sm);
  font-family: inherit;
  box-sizing: border-box;
}

.rt2-context-select__item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border: none;
  border-radius: var(--rt-radius-sm);
  background: transparent;
  color: var(--rt-text);
  font-size: var(--rt-text-sm);
  font-family: inherit;
  cursor: pointer;
}

.rt2-context-select__item:hover,
.rt2-context-select__item--active {
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
}

.rt2-topbar__spacer {
  flex: 1 1;
}

.rt2-topbar__search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(320px, 30vw);
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-md);
  background: var(--rt-bg);
  color: var(--rt-text-muted);
  font-size: var(--rt-text-sm);
  cursor: pointer;
}

.rt2-topbar__search kbd {
  margin-left: auto;
  font-size: 10px;
  padding: 2px 5px;
  border: 1px solid var(--rt-border);
  border-radius: 4px;
  background: var(--rt-surface);
}

.rt2-topbar__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.rt2-topbar__notify {
  position: relative;
}

.rt2-topbar__badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--rt-danger);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rt2-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 280px;
  max-height: 360px;
  overflow: auto;
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: 50;
  padding: 8px;
}

.rt2-dropdown__item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border: none;
  border-radius: var(--rt-radius-sm);
  background: transparent;
  color: var(--rt-text);
  font-size: var(--rt-text-sm);
  font-family: inherit;
  cursor: pointer;
}

.rt2-dropdown__item:hover {
  background: var(--rt-bg);
}

.rt2-dropdown__item--active {
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
}

.rt2-dropdown__meta {
  font-size: 11px;
  color: var(--rt-text-muted);
  margin-top: 2px;
}

.rt2-user-menu {
  min-width: 220px;
  padding: 6px;
}

.rt2-user-menu__header {
  padding: 8px 10px 6px;
  min-width: 0;
}

.rt2-user-menu__name {
  display: block;
  font-size: var(--rt-text-sm);
  color: var(--rt-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt2-user-menu__divider {
  height: 1px;
  margin: 4px 0;
  background: var(--rt-border);
}

.rt2-user-menu__item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rt2-user-menu__item > svg {
  flex-shrink: 0;
  color: var(--rt-text-muted);
}

.rt2-user-menu__item:focus-visible {
  outline: 2px solid var(--rt-primary);
  outline-offset: -2px;
}

.rt2-user-menu__item--danger,
.rt2-user-menu__item--danger > svg {
  color: var(--rt-danger);
}

.rt2-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  overflow: hidden;
}

.rt2-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Sidebar */
.rt2-sidebar {
  width: 100%;
  height: 100%;
  background: var(--sidebar-background, var(--rt-surface));
  border-right: 1px solid var(--sidebar-border, var(--rt-border));
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  transition: width 180ms ease;
}

.rt2-sidebar__brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 56px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--rt-border-subtle);
  flex-shrink: 0;
}

.rt2-sidebar--collapsed .rt2-sidebar__brand {
  justify-content: center;
  padding: 10px 6px;
}

.rt2-sidebar__brand-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-text-muted);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt2-sidebar__context {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1;
}

.rt2-sidebar__context-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
}

.rt2-sidebar--workspace .rt2-sidebar__context-mark {
  background: linear-gradient(135deg, #0ea5e9, #14b8a6);
}

.rt2-sidebar__context-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}

.rt2-sidebar__context-kind {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rt2-sidebar__context-name {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--rt-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rt2-sidebar--collapsed .rt2-sidebar__context {
  flex: 0 0 auto;
}

.rt2-sidebar--collapsed .rt2-sidebar__toggle {
  display: none;
}

.rt2-sidebar__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: var(--rt-radius-md, 8px);
  background: transparent;
  color: var(--rt-text-muted);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 150ms ease, color 150ms ease;
}

.rt2-sidebar__toggle:hover {
  background: var(--rt-surface-hover, var(--rt-bg));
  color: var(--rt-text);
}

.rt2-sidebar__toggle--active {
  color: var(--rt-primary);
  background: var(--rt-primary-subtle);
}

.rt2-sidebar__toggle:focus-visible {
  outline: 2px solid var(--rt-primary);
  outline-offset: 2px;
}

.rt2-sidebar__scroll {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 10px 16px;
  min-height: 0;
}

.rt2-sidebar--collapsed .rt2-sidebar__scroll {
  padding: 10px 6px;
}

.rt2-sidebar__section {
  margin-bottom: 14px;
}

.rt2-sidebar__section-title {
  padding: 4px 10px 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--rt-text-muted);
}

.rt2-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: none;
  border-radius: var(--rt-radius-md);
  background: transparent;
  color: var(--rt-text-secondary);
  font-size: var(--rt-text-sm);
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  margin-bottom: 2px;
  transition: background 150ms ease, color 150ms ease;
}

.rt2-sidebar--collapsed .rt2-nav-item {
  justify-content: center;
  padding: 0;
  width: 40px;
  margin-left: auto;
  margin-right: auto;
}

.rt2-nav-item:hover {
  background: var(--rt-surface-hover, var(--rt-bg));
  color: var(--rt-text);
}

.rt2-nav-item {
  position: relative;
}

.rt2-nav-item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rt2-nav-item--active {
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
  font-weight: 600;
}

.rt2-nav-item--active::before {
  content: '';
  position: absolute;
  left: -10px;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: var(--rt-primary);
}

.rt2-sidebar--collapsed .rt2-nav-item--active::before {
  left: -6px;
}

.rt2-nav-item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--rt-primary);
}

.rt2-nav-item svg {
  flex-shrink: 0;
  opacity: 0.85;
  width: 18px;
  height: 18px;
}

.rt2-sidebar__footer {
  padding: 10px;
  border-top: 1px solid var(--rt-border-subtle);
  flex-shrink: 0;
}

.rt2-sidebar--collapsed .rt2-sidebar__footer {
  padding: 8px 6px;
}

.rt2-main {
  grid-column: 2;
  grid-row: 2;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px 32px;
  background: var(--rt-bg);
  position: relative;
}

.rt2-main[data-rt-shell-locked] {
  overflow: hidden;
}

.rt2-main > .dashboard-content {
  padding: 0 !important;
  margin: 0 !important;
  max-width: none !important;
  height: auto !important;
  overflow: visible !important;
}

/* Command palette — single flush surface (no nested search box) */
.rt2-cmd-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.5));
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 12vh;
  padding-left: 16px;
  padding-right: 16px;
}

.rt2-cmd {
  width: min(580px, 100%);
  max-height: min(480px, 70vh);
  display: flex;
  flex-direction: column;
  background: var(--modal-background, var(--surface, var(--rt-surface)));
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 16px;
  box-shadow: var(--modal-shadow, 0 24px 64px rgba(15, 23, 42, 0.28));
  overflow: hidden;
}

.rt2-cmd__input-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 16px 18px;
  border: none;
  border-bottom: 1px solid var(--rt-border-subtle, var(--rt-border, var(--border)));
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  flex: 0 0 auto;
}

.rt2-cmd__icon {
  color: var(--rt-text-muted, var(--text-secondary, #64748b));
  flex-shrink: 0;
}

.rt2-cmd__input,
.rt2-cmd input,
.rt2-cmd input[type='search'],
.rt2-cmd input:not([type]) {
  flex: 1 1;
  min-width: 0;
  height: auto;
  min-height: 24px;
  margin: 0;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  font-size: 1rem;
  line-height: 1.4;
  font-family: inherit;
  font-weight: 500;
  box-sizing: border-box;
  background: transparent !important;
  color: var(--rt-text, var(--text-primary)) !important;
  appearance: none;
}

.rt2-cmd__input:focus,
.rt2-cmd input:focus,
.rt2-cmd input[type='search']:focus {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rt2-cmd__input::placeholder,
.rt2-cmd input::placeholder {
  color: var(--input-placeholder, var(--rt-text-muted, #94a3b8)) !important;
  font-weight: 400;
}

.rt2-cmd input[type='search']::-webkit-search-decoration,
.rt2-cmd input[type='search']::-webkit-search-cancel-button,
.rt2-cmd input[type='search']::-webkit-search-results-button,
.rt2-cmd input[type='search']::-webkit-search-results-decoration {
  appearance: none;
  display: none;
}

.rt2-cmd__clear {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: var(--surface-2, color-mix(in srgb, var(--rt-text, #0f172a) 6%, transparent));
  color: var(--rt-text-muted, #64748b);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.rt2-cmd__clear:hover {
  background: color-mix(in srgb, var(--rt-text, #0f172a) 10%, transparent);
  color: var(--rt-text, var(--text-primary));
}

.rt2-cmd__esc {
  font-size: 11px;
  padding: 3px 7px;
  border-radius: 6px;
  border: 1px solid var(--rt-border, var(--border));
  color: var(--rt-text-muted, #64748b);
  background: transparent;
  flex-shrink: 0;
  font-family: inherit;
}

.rt2-cmd__list {
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(340px, 46vh);
  overflow: auto;
  padding: 8px;
}

.rt2-cmd__list--empty {
  max-height: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.rt2-cmd__empty {
  padding: 28px 20px;
  text-align: center;
  max-width: 360px;
}

.rt2-cmd__empty-title {
  margin: 0 0 6px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--rt-text, var(--text-primary));
}

.rt2-cmd__empty-desc {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--rt-text-muted, var(--text-secondary, #64748b));
}

.rt2-cmd__group + .rt2-cmd__group {
  margin-top: 4px;
}

.rt2-cmd__group-label {
  padding: 8px 12px 4px;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--rt-text-muted, var(--text-secondary, #64748b));
}

.rt2-cmd__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  color: var(--rt-text, var(--text-primary));
  font-size: 0.875rem;
}

.rt2-cmd__item-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt2-cmd__item:hover,
.rt2-cmd__item--active {
  background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);
  color: var(--primary, #2563eb);
}

.rt2-cmd__hint {
  font-size: 11px;
  color: var(--rt-text-muted, #64748b);
  flex-shrink: 0;
}

.rt2-cmd__footer {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid var(--rt-border-subtle, var(--rt-border, var(--border)));
  font-size: 11px;
  color: var(--rt-text-muted, #64748b);
  background: color-mix(in srgb, var(--surface, #fff) 92%, var(--rt-text, #0f172a) 4%);
}

.rt2-cmd__footer kbd {
  display: inline-block;
  padding: 1px 5px;
  margin-right: 4px;
  border: 1px solid var(--rt-border, var(--border));
  border-radius: 4px;
  font-size: 10px;
  font-family: inherit;
  background: var(--surface, #fff);
}

.rt2-cmd__count {
  margin-left: auto;
}

/* Project Overview */
.rt2-overview__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.rt2-overview__title {
  margin: 0;
  font-size: var(--rt-text-xl);
  font-weight: 700;
  letter-spacing: -0.02em;
}

.rt2-overview__desc {
  margin: 4px 0 0;
  font-size: var(--rt-text-sm);
  color: var(--rt-text-muted);
  max-width: 56ch;
}

.rt2-overview__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

.rt2-metrics {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.rt2-metric {
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  padding: 12px 14px;
}

.rt2-metric__label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-text-muted);
  margin-bottom: 4px;
}

.rt2-metric__value {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.rt2-overview-grid {
  display: grid;
  grid-template-columns: 1.15fr 1fr;
  gap: 14px;
  align-items: start;
}

.rt2-overview-grid--triple {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1100px) {
  .rt2-overview-grid,
  .rt2-overview-grid--triple {
    grid-template-columns: 1fr;
  }
}

.rt2-health-chart {
  display: grid;
  grid-template-columns: 1fr 160px;
  gap: 16px;
  align-items: center;
  min-height: 220px;
}

.rt2-health-chart__canvas {
  height: 220px;
  position: relative;
}

.rt2-health-chart__legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rt2-health-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--rt-text-sm);
  color: var(--rt-text-secondary);
}

.rt2-health-stat strong {
  margin-left: auto;
  color: var(--rt-text);
  font-variant-numeric: tabular-nums;
}

.rt2-trend-chart {
  height: 240px;
  position: relative;
}

.rt2-table-wrap {
  width: 100%;
  overflow-x: auto;
}

@media (max-width: 900px) {
  .rt2-health-chart {
    grid-template-columns: 1fr;
  }
}

.rt2-panel {
  background: linear-gradient(180deg, color-mix(in srgb, var(--rt-surface) 94%, #fff) 0%, var(--rt-surface) 100%);
  border: 1px solid var(--rt-border);
  border-radius: 14px;
  box-shadow: var(--rt-shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));
  overflow: hidden;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.rt2-panel:hover {
  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 18%, var(--rt-border));
  box-shadow: 0 10px 24px -18px rgba(15, 23, 42, 0.28);
}

.rt2-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--rt-border-subtle);
  background: linear-gradient(180deg, #f8fafc 0%, transparent 100%);
}

.rt2-panel__title {
  margin: 0;
  font-size: var(--rt-text-sm);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--rt-text, #0f172a);
}

.rt2-panel__body {
  padding: 14px 16px;
}

.rt2-attention-item,
.rt2-activity-item,
.rt2-exec-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid var(--rt-border-subtle);
  font-size: var(--rt-text-sm);
}

.rt2-attention-item:last-child,
.rt2-activity-item:last-child,
.rt2-exec-item:last-child {
  border-bottom: none;
}

.rt2-muted {
  color: var(--rt-text-muted);
  font-size: var(--rt-text-xs);
}

.rt2-empty {
  padding: 20px 8px;
  text-align: center;
  color: var(--rt-text-muted);
  font-size: var(--rt-text-sm);
}

.rt2-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--rt-text-sm);
}

.rt2-table th {
  text-align: left;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-text-muted);
  font-weight: 600;
  padding: 8px 10px;
  border-bottom: 1px solid var(--rt-border);
  background: var(--table-header, var(--rt-bg));
}

.rt2-table td {
  padding: 9px 10px;
  border-bottom: 1px solid var(--rt-border-subtle);
  color: var(--rt-text);
  background: var(--table-row, transparent);
}

.rt2-table tr:hover td {
  background: var(--table-hover, var(--rt-surface-hover));
}

.rt2-link {
  background: none;
  border: none;
  padding: 0;
  color: var(--rt-primary);
  font-weight: 600;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
}

.rt2-link:hover {
  text-decoration: underline;
}

/* Unlocked sidebar pushes content aside on hover — the grid column expands like the locked state. */
@media (min-width: 1025px) {
  .rt2-shell--unlocked {
    grid-template-columns: var(--rt-sidebar-collapsed) minmax(0, 1fr);
  }

  .rt2-shell--unlocked.rt2-shell--expanded {
    grid-template-columns: var(--rt-sidebar-w) minmax(0, 1fr);
  }

  .rt2-shell--unlocked .rt2-sidebar-slot {
    z-index: var(--z-sidebar, 30);
  }

  .rt2-shell--locked {
    grid-template-columns: var(--rt-sidebar-w) minmax(0, 1fr);
  }
}

@media (max-width: 1200px) {
  .rt2-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .rt2-overview-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1024px) {
  .rt2-shell,
  .rt2-shell--collapsed,
  .rt2-shell--expanded {
    grid-template-columns: 1fr;
  }

  .rt2-sidebar-slot {
    position: fixed;
    top: var(--rt-topbar-h);
    left: 0;
    bottom: 0;
    width: var(--rt-sidebar-w);
    transform: translateX(-100%);
    transition: transform 180ms ease;
    z-index: 50;
    box-shadow: var(--shadow-lg);
  }

  .rt2-sidebar-slot--open {
    transform: translateX(0);
  }

  .rt2-sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    border: none;
    background: var(--modal-backdrop);
    z-index: 45;
    cursor: pointer;
  }

  .rt2-sidebar {
    width: var(--rt-sidebar-w) !important;
  }

  .rt2-main {
    grid-column: 1;
  }

  .rt2-topbar__search span,
  .rt2-topbar__search kbd {
    display: none;
  }

  .rt2-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .rt2-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .rt2-overview-grid {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .rt2-shell,
  .rt2-nav-item,
  .rt-btn,
  .rt2-sidebar-slot {
    transition: none;
  }
}

/* ── First-run product tour ─────────────────────────────── */
.rt-tour {
  position: fixed;
  inset: 0;
  z-index: calc(var(--z-toast, 1400) + 20);
  pointer-events: none;
}

.rt-tour__scrim {
  position: absolute;
  inset: 0;
  pointer-events: auto;
  background: transparent;
}

.rt-tour__scrim--full {
  background: rgba(2, 6, 23, 0.55);
  backdrop-filter: blur(2px);
  animation: rt-tour-fade var(--duration-normal, 200ms) var(--ease-out, ease-out);
}

.rt-tour__spot {
  position: fixed;
  border-radius: var(--rt-radius-md, 10px);
  box-shadow:
    0 0 0 2px var(--rt-primary),
    0 0 0 6px color-mix(in srgb, var(--rt-primary) 28%, transparent),
    0 0 0 9999px rgba(2, 6, 23, 0.55);
  transition:
    top var(--duration-slow, 280ms) var(--ease-out, ease-out),
    left var(--duration-slow, 280ms) var(--ease-out, ease-out),
    width var(--duration-slow, 280ms) var(--ease-out, ease-out),
    height var(--duration-slow, 280ms) var(--ease-out, ease-out);
  pointer-events: none;
}

.rt-tour__card {
  position: fixed;
  width: min(340px, calc(100vw - 24px));
  padding: 18px 18px 14px;
  border-radius: var(--radius-xl, 12px);
  border: 1px solid var(--rt-border);
  background: var(--surface-elevated, var(--rt-surface));
  color: var(--rt-text);
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
  animation: rt-tour-pop var(--duration-normal, 200ms) var(--ease-out, ease-out);
}

.rt-tour__card--hero {
  width: min(420px, calc(100vw - 24px));
  padding: 28px 26px 18px;
  text-align: center;
}

.rt-tour__close {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: var(--rt-radius-sm, 6px);
  background: transparent;
  color: var(--rt-text-muted);
  cursor: pointer;
}

.rt-tour__close:hover {
  background: var(--rt-bg);
  color: var(--rt-text);
}

.rt-tour__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
}

.rt-tour__badge--done {
  background: color-mix(in srgb, var(--success, #16a34a) 16%, transparent);
  color: var(--success, #16a34a);
}

.rt-tour__eyebrow {
  margin-bottom: 6px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-primary);
}

.rt-tour__title {
  margin: 0 28px 6px 0;
  font-size: var(--type-section-title, 16px);
  font-weight: 650;
  line-height: 1.35;
  color: var(--rt-text);
}

.rt-tour__card--hero .rt-tour__title {
  margin: 0 0 8px;
  font-size: 19px;
}

.rt-tour__body {
  margin: 0;
  font-size: var(--type-body, 14px);
  line-height: 1.55;
  color: var(--rt-text-muted);
}

.rt-tour__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
}

.rt-tour__card--hero .rt-tour__footer {
  justify-content: center;
  margin-top: 22px;
}

.rt-tour__card--hero .rt-tour__footer > span:empty {
  display: none;
}

.rt-tour__actions {
  display: inline-flex;
  gap: 8px;
}

.rt-tour__actions .rt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.rt-tour__dots {
  display: inline-flex;
  gap: 5px;
}

.rt-tour__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--rt-border);
  transition: width var(--duration-normal, 200ms) var(--ease-out, ease-out), background var(--duration-normal, 200ms);
}

.rt-tour__dot--active {
  width: 16px;
  background: var(--rt-primary);
}

@keyframes rt-tour-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes rt-tour-pop {
  from { opacity: 0; transform: translateY(4px) scale(0.98); }
  to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .rt-tour__spot,
  .rt-tour__dot { transition: none; }
  .rt-tour__card,
  .rt-tour__scrim--full { animation: none; }
}

.rt-tour__card--list {
  width: min(372px, calc(100vw - 24px));
}

.rt-tour__list {
  display: grid;
  gap: 8px;
  margin: 2px 0 0;
  padding: 0;
  list-style: none;
}

.rt-tour__list li {
  display: grid;
  gap: 1px;
  padding: 7px 10px;
  border-radius: var(--rt-radius-sm, 6px);
  background: var(--rt-bg);
  border: 1px solid var(--rt-border);
}

.rt-tour__list strong {
  font-size: 13px;
  font-weight: 600;
  color: var(--rt-text);
}

.rt-tour__list span {
  font-size: var(--type-supporting, 12.5px);
  line-height: 1.45;
  color: var(--rt-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-shell.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sDAAsD;EACtD,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uDAAuD;EACvD,yCAAyC;EACzC,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2DAA2D;EAC3D,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,+DAA+D;EAC/D,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,wDAAwD;EACxD,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,sEAAsE;EACtE,iDAAiD;EACjD,mBAAmB;EACnB,mEAAmE;EACnE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,iFAAiF;EACjF,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;;;;EAIE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,qDAAqD;EAErD,gBAAgB;AAClB;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;;;;EAKE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yFAAyF;EACzF,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,8EAA8E;EAC9E,eAAe;EACf,oCAAoC;EACpC,oFAAoF;AACtF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iDAAiD;EACjD,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,+GAA+G;EAC/G,kCAAkC;EAClC,mBAAmB;EACnB,iEAAiE;EACjE,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,kFAAkF;EAClF,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gDAAgD;EAChD,iEAAiE;AACnE;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oGAAoG;AACpG;EACE;IACE,iEAAiE;EACnE;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,OAAO;IACP,SAAS;IACT,0BAA0B;IAC1B,4BAA4B;IAC5B,gCAAgC;IAChC,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC;;;qCAGmC;EACnC;;;;gEAI8D;EAC9D,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,uBAAuB;EACvB,qCAAqC;EACrC,kCAAkC;EAClC,sDAAsD;EACtD,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,mHAAmH;AACrH;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE;kBACgB,gBAAgB,EAAE;EAClC;0BACwB,eAAe,EAAE;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,2BAA2B;AAC7B","sourcesContent":["/* RobiTest 2.0 App Shell — primary scroll lives in .rt2-main */\n\n.rt2-shell {\n  display: grid;\n  grid-template-columns: var(--rt-sidebar-collapsed) 1fr;\n  grid-template-rows: var(--rt-topbar-h) minmax(0, 1fr);\n  flex: 1 1 auto;\n  height: 100%;\n  max-height: 100%;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n  background: var(--rt-bg);\n  color: var(--rt-text);\n  transition: grid-template-columns 180ms ease;\n}\n\n.rt2-shell--expanded {\n  grid-template-columns: var(--rt-sidebar-w) 1fr;\n}\n\n.rt2-shell--collapsed {\n  grid-template-columns: var(--rt-sidebar-collapsed) 1fr;\n}\n\n.rt2-sidebar-slot {\n  grid-column: 1;\n  grid-row: 2;\n  min-height: 0;\n  min-width: 0;\n  height: 100%;\n  z-index: 30;\n  position: relative;\n}\n\n.rt2-sidebar-backdrop {\n  display: none;\n}\n\n.rt2-topbar {\n  grid-column: 1 / -1;\n  grid-row: 1;\n  height: var(--rt-topbar-h);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 16px;\n  background: var(--topbar-background, var(--rt-surface));\n  border-bottom: 1px solid var(--rt-border);\n  z-index: 40;\n  backdrop-filter: blur(8px);\n}\n\n.rt2-topbar__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 120px;\n  text-decoration: none;\n  color: var(--rt-text);\n  font-weight: 700;\n  font-size: 1rem;\n  letter-spacing: -0.02em;\n}\n\n.rt2-topbar__brand svg {\n  color: var(--rt-primary);\n}\n\n.rt2-topbar__context {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.rt2-topbar__sep {\n  width: 1px;\n  height: 22px;\n  background: var(--rt-border);\n}\n\n.rt2-context-select {\n  position: relative;\n}\n\n.rt2-context-select__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 220px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-md);\n  background: var(--rt-surface);\n  color: var(--rt-text);\n  font-size: var(--rt-text-sm);\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.rt2-context-select__btn:hover {\n  border-color: var(--rt-primary-border);\n  background: var(--rt-primary-subtle);\n}\n\n.rt2-context-select__label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-text-muted);\n  font-weight: 600;\n}\n\n.rt2-context-select__value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 140px;\n}\n\n.rt2-context-select__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  min-width: 280px;\n  max-width: min(420px, 90vw);\n  max-height: min(480px, 70vh);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: 50;\n  padding: 6px;\n}\n\n.rt2-context-select__list {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  min-height: 0;\n  max-height: min(380px, 55vh);\n}\n\n.rt2-context-select__footer {\n  flex: 0 0 auto;\n  padding: 6px 10px 2px;\n  font-size: 11px;\n  color: var(--rt-text-muted, var(--text-secondary, #64748b));\n  border-top: 1px solid var(--rt-border);\n  margin-top: 4px;\n}\n\n.rt2-context-select__search {\n  width: 100%;\n  height: 32px;\n  margin-bottom: 6px;\n  padding: 0 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-md);\n  font-size: var(--rt-text-sm);\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.rt2-context-select__item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 8px 10px;\n  border: none;\n  border-radius: var(--rt-radius-sm);\n  background: transparent;\n  color: var(--rt-text);\n  font-size: var(--rt-text-sm);\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.rt2-context-select__item:hover,\n.rt2-context-select__item--active {\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n}\n\n.rt2-topbar__spacer {\n  flex: 1;\n}\n\n.rt2-topbar__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(320px, 30vw);\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-md);\n  background: var(--rt-bg);\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-sm);\n  cursor: pointer;\n}\n\n.rt2-topbar__search kbd {\n  margin-left: auto;\n  font-size: 10px;\n  padding: 2px 5px;\n  border: 1px solid var(--rt-border);\n  border-radius: 4px;\n  background: var(--rt-surface);\n}\n\n.rt2-topbar__actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rt2-topbar__notify {\n  position: relative;\n}\n\n.rt2-topbar__badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--rt-danger);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rt2-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 280px;\n  max-height: 360px;\n  overflow: auto;\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: 50;\n  padding: 8px;\n}\n\n.rt2-dropdown__item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 8px 10px;\n  border: none;\n  border-radius: var(--rt-radius-sm);\n  background: transparent;\n  color: var(--rt-text);\n  font-size: var(--rt-text-sm);\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.rt2-dropdown__item:hover {\n  background: var(--rt-bg);\n}\n\n.rt2-dropdown__item--active {\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n}\n\n.rt2-dropdown__meta {\n  font-size: 11px;\n  color: var(--rt-text-muted);\n  margin-top: 2px;\n}\n\n.rt2-user-menu {\n  min-width: 220px;\n  padding: 6px;\n}\n\n.rt2-user-menu__header {\n  padding: 8px 10px 6px;\n  min-width: 0;\n}\n\n.rt2-user-menu__name {\n  display: block;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt2-user-menu__divider {\n  height: 1px;\n  margin: 4px 0;\n  background: var(--rt-border);\n}\n\n.rt2-user-menu__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rt2-user-menu__item > svg {\n  flex-shrink: 0;\n  color: var(--rt-text-muted);\n}\n\n.rt2-user-menu__item:focus-visible {\n  outline: 2px solid var(--rt-primary);\n  outline-offset: -2px;\n}\n\n.rt2-user-menu__item--danger,\n.rt2-user-menu__item--danger > svg {\n  color: var(--rt-danger);\n}\n\n.rt2-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.rt2-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Sidebar */\n.rt2-sidebar {\n  width: 100%;\n  height: 100%;\n  background: var(--sidebar-background, var(--rt-surface));\n  border-right: 1px solid var(--sidebar-border, var(--rt-border));\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  transition: width 180ms ease;\n}\n\n.rt2-sidebar__brand {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 56px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--rt-border-subtle);\n  flex-shrink: 0;\n}\n\n.rt2-sidebar--collapsed .rt2-sidebar__brand {\n  justify-content: center;\n  padding: 10px 6px;\n}\n\n.rt2-sidebar__brand-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt2-sidebar__context {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex: 1;\n}\n\n.rt2-sidebar__context-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #3b82f6, #6366f1);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);\n}\n\n.rt2-sidebar--workspace .rt2-sidebar__context-mark {\n  background: linear-gradient(135deg, #0ea5e9, #14b8a6);\n}\n\n.rt2-sidebar__context-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.rt2-sidebar__context-kind {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rt2-sidebar__context-name {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--rt-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rt2-sidebar--collapsed .rt2-sidebar__context {\n  flex: 0 0 auto;\n}\n\n.rt2-sidebar--collapsed .rt2-sidebar__toggle {\n  display: none;\n}\n\n.rt2-sidebar__toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: var(--rt-radius-md, 8px);\n  background: transparent;\n  color: var(--rt-text-muted);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.rt2-sidebar__toggle:hover {\n  background: var(--rt-surface-hover, var(--rt-bg));\n  color: var(--rt-text);\n}\n\n.rt2-sidebar__toggle--active {\n  color: var(--rt-primary);\n  background: var(--rt-primary-subtle);\n}\n\n.rt2-sidebar__toggle:focus-visible {\n  outline: 2px solid var(--rt-primary);\n  outline-offset: 2px;\n}\n\n.rt2-sidebar__scroll {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 10px 16px;\n  min-height: 0;\n}\n\n.rt2-sidebar--collapsed .rt2-sidebar__scroll {\n  padding: 10px 6px;\n}\n\n.rt2-sidebar__section {\n  margin-bottom: 14px;\n}\n\n.rt2-sidebar__section-title {\n  padding: 4px 10px 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted);\n}\n\n.rt2-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  height: 36px;\n  padding: 0 10px;\n  border: none;\n  border-radius: var(--rt-radius-md);\n  background: transparent;\n  color: var(--rt-text-secondary);\n  font-size: var(--rt-text-sm);\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n  margin-bottom: 2px;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.rt2-sidebar--collapsed .rt2-nav-item {\n  justify-content: center;\n  padding: 0;\n  width: 40px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.rt2-nav-item:hover {\n  background: var(--rt-surface-hover, var(--rt-bg));\n  color: var(--rt-text);\n}\n\n.rt2-nav-item {\n  position: relative;\n}\n\n.rt2-nav-item span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rt2-nav-item--active {\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n  font-weight: 600;\n}\n\n.rt2-nav-item--active::before {\n  content: '';\n  position: absolute;\n  left: -10px;\n  top: 8px;\n  bottom: 8px;\n  width: 3px;\n  border-radius: 0 3px 3px 0;\n  background: var(--rt-primary);\n}\n\n.rt2-sidebar--collapsed .rt2-nav-item--active::before {\n  left: -6px;\n}\n\n.rt2-nav-item:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--rt-primary);\n}\n\n.rt2-nav-item svg {\n  flex-shrink: 0;\n  opacity: 0.85;\n  width: 18px;\n  height: 18px;\n}\n\n.rt2-sidebar__footer {\n  padding: 10px;\n  border-top: 1px solid var(--rt-border-subtle);\n  flex-shrink: 0;\n}\n\n.rt2-sidebar--collapsed .rt2-sidebar__footer {\n  padding: 8px 6px;\n}\n\n.rt2-main {\n  grid-column: 2;\n  grid-row: 2;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 20px 24px 32px;\n  background: var(--rt-bg);\n  position: relative;\n}\n\n.rt2-main[data-rt-shell-locked] {\n  overflow: hidden;\n}\n\n.rt2-main > .dashboard-content {\n  padding: 0 !important;\n  margin: 0 !important;\n  max-width: none !important;\n  height: auto !important;\n  overflow: visible !important;\n}\n\n/* Command palette — single flush surface (no nested search box) */\n.rt2-cmd-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.5));\n  z-index: 200;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 12vh;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.rt2-cmd {\n  width: min(580px, 100%);\n  max-height: min(480px, 70vh);\n  display: flex;\n  flex-direction: column;\n  background: var(--modal-background, var(--surface, var(--rt-surface)));\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 16px;\n  box-shadow: var(--modal-shadow, 0 24px 64px rgba(15, 23, 42, 0.28));\n  overflow: hidden;\n}\n\n.rt2-cmd__input-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0;\n  padding: 16px 18px;\n  border: none;\n  border-bottom: 1px solid var(--rt-border-subtle, var(--rt-border, var(--border)));\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  flex: 0 0 auto;\n}\n\n.rt2-cmd__icon {\n  color: var(--rt-text-muted, var(--text-secondary, #64748b));\n  flex-shrink: 0;\n}\n\n.rt2-cmd__input,\n.rt2-cmd input,\n.rt2-cmd input[type='search'],\n.rt2-cmd input:not([type]) {\n  flex: 1;\n  min-width: 0;\n  height: auto;\n  min-height: 24px;\n  margin: 0;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n  font-size: 1rem;\n  line-height: 1.4;\n  font-family: inherit;\n  font-weight: 500;\n  box-sizing: border-box;\n  background: transparent !important;\n  color: var(--rt-text, var(--text-primary)) !important;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.rt2-cmd__input:focus,\n.rt2-cmd input:focus,\n.rt2-cmd input[type='search']:focus {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rt2-cmd__input::placeholder,\n.rt2-cmd input::placeholder {\n  color: var(--input-placeholder, var(--rt-text-muted, #94a3b8)) !important;\n  font-weight: 400;\n}\n\n.rt2-cmd input[type='search']::-webkit-search-decoration,\n.rt2-cmd input[type='search']::-webkit-search-cancel-button,\n.rt2-cmd input[type='search']::-webkit-search-results-button,\n.rt2-cmd input[type='search']::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  appearance: none;\n  display: none;\n}\n\n.rt2-cmd__clear {\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 8px;\n  background: var(--surface-2, color-mix(in srgb, var(--rt-text, #0f172a) 6%, transparent));\n  color: var(--rt-text-muted, #64748b);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.rt2-cmd__clear:hover {\n  background: color-mix(in srgb, var(--rt-text, #0f172a) 10%, transparent);\n  color: var(--rt-text, var(--text-primary));\n}\n\n.rt2-cmd__esc {\n  font-size: 11px;\n  padding: 3px 7px;\n  border-radius: 6px;\n  border: 1px solid var(--rt-border, var(--border));\n  color: var(--rt-text-muted, #64748b);\n  background: transparent;\n  flex-shrink: 0;\n  font-family: inherit;\n}\n\n.rt2-cmd__list {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: min(340px, 46vh);\n  overflow: auto;\n  padding: 8px;\n}\n\n.rt2-cmd__list--empty {\n  max-height: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n}\n\n.rt2-cmd__empty {\n  padding: 28px 20px;\n  text-align: center;\n  max-width: 360px;\n}\n\n.rt2-cmd__empty-title {\n  margin: 0 0 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--rt-text, var(--text-primary));\n}\n\n.rt2-cmd__empty-desc {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--rt-text-muted, var(--text-secondary, #64748b));\n}\n\n.rt2-cmd__group + .rt2-cmd__group {\n  margin-top: 4px;\n}\n\n.rt2-cmd__group-label {\n  padding: 8px 12px 4px;\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted, var(--text-secondary, #64748b));\n}\n\n.rt2-cmd__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  color: var(--rt-text, var(--text-primary));\n  font-size: 0.875rem;\n}\n\n.rt2-cmd__item-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt2-cmd__item:hover,\n.rt2-cmd__item--active {\n  background: color-mix(in srgb, var(--primary, #2563eb) 12%, transparent);\n  color: var(--primary, #2563eb);\n}\n\n.rt2-cmd__hint {\n  font-size: 11px;\n  color: var(--rt-text-muted, #64748b);\n  flex-shrink: 0;\n}\n\n.rt2-cmd__footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  padding: 10px 16px;\n  border-top: 1px solid var(--rt-border-subtle, var(--rt-border, var(--border)));\n  font-size: 11px;\n  color: var(--rt-text-muted, #64748b);\n  background: color-mix(in srgb, var(--surface, #fff) 92%, var(--rt-text, #0f172a) 4%);\n}\n\n.rt2-cmd__footer kbd {\n  display: inline-block;\n  padding: 1px 5px;\n  margin-right: 4px;\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: 4px;\n  font-size: 10px;\n  font-family: inherit;\n  background: var(--surface, #fff);\n}\n\n.rt2-cmd__count {\n  margin-left: auto;\n}\n\n/* Project Overview */\n.rt2-overview__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.rt2-overview__title {\n  margin: 0;\n  font-size: var(--rt-text-xl);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.rt2-overview__desc {\n  margin: 4px 0 0;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text-muted);\n  max-width: 56ch;\n}\n\n.rt2-overview__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.rt2-metrics {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.rt2-metric {\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  padding: 12px 14px;\n}\n\n.rt2-metric__label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-text-muted);\n  margin-bottom: 4px;\n}\n\n.rt2-metric__value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.rt2-overview-grid {\n  display: grid;\n  grid-template-columns: 1.15fr 1fr;\n  gap: 14px;\n  align-items: start;\n}\n\n.rt2-overview-grid--triple {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 1100px) {\n  .rt2-overview-grid,\n  .rt2-overview-grid--triple {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rt2-health-chart {\n  display: grid;\n  grid-template-columns: 1fr 160px;\n  gap: 16px;\n  align-items: center;\n  min-height: 220px;\n}\n\n.rt2-health-chart__canvas {\n  height: 220px;\n  position: relative;\n}\n\n.rt2-health-chart__legend {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rt2-health-stat {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text-secondary);\n}\n\n.rt2-health-stat strong {\n  margin-left: auto;\n  color: var(--rt-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.rt2-trend-chart {\n  height: 240px;\n  position: relative;\n}\n\n.rt2-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n@media (max-width: 900px) {\n  .rt2-health-chart {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rt2-panel {\n  background: linear-gradient(180deg, color-mix(in srgb, var(--rt-surface) 94%, #fff) 0%, var(--rt-surface) 100%);\n  border: 1px solid var(--rt-border);\n  border-radius: 14px;\n  box-shadow: var(--rt-shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));\n  overflow: hidden;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.rt2-panel:hover {\n  border-color: color-mix(in srgb, var(--rt-primary, #2563eb) 18%, var(--rt-border));\n  box-shadow: 0 10px 24px -18px rgba(15, 23, 42, 0.28);\n}\n\n.rt2-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--rt-border-subtle);\n  background: linear-gradient(180deg, #f8fafc 0%, transparent 100%);\n}\n\n.rt2-panel__title {\n  margin: 0;\n  font-size: var(--rt-text-sm);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--rt-text, #0f172a);\n}\n\n.rt2-panel__body {\n  padding: 14px 16px;\n}\n\n.rt2-attention-item,\n.rt2-activity-item,\n.rt2-exec-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--rt-border-subtle);\n  font-size: var(--rt-text-sm);\n}\n\n.rt2-attention-item:last-child,\n.rt2-activity-item:last-child,\n.rt2-exec-item:last-child {\n  border-bottom: none;\n}\n\n.rt2-muted {\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-xs);\n}\n\n.rt2-empty {\n  padding: 20px 8px;\n  text-align: center;\n  color: var(--rt-text-muted);\n  font-size: var(--rt-text-sm);\n}\n\n.rt2-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--rt-text-sm);\n}\n\n.rt2-table th {\n  text-align: left;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-text-muted);\n  font-weight: 600;\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--rt-border);\n  background: var(--table-header, var(--rt-bg));\n}\n\n.rt2-table td {\n  padding: 9px 10px;\n  border-bottom: 1px solid var(--rt-border-subtle);\n  color: var(--rt-text);\n  background: var(--table-row, transparent);\n}\n\n.rt2-table tr:hover td {\n  background: var(--table-hover, var(--rt-surface-hover));\n}\n\n.rt2-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--rt-primary);\n  font-weight: 600;\n  font-size: inherit;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.rt2-link:hover {\n  text-decoration: underline;\n}\n\n/* Unlocked sidebar pushes content aside on hover — the grid column expands like the locked state. */\n@media (min-width: 1025px) {\n  .rt2-shell--unlocked {\n    grid-template-columns: var(--rt-sidebar-collapsed) minmax(0, 1fr);\n  }\n\n  .rt2-shell--unlocked.rt2-shell--expanded {\n    grid-template-columns: var(--rt-sidebar-w) minmax(0, 1fr);\n  }\n\n  .rt2-shell--unlocked .rt2-sidebar-slot {\n    z-index: var(--z-sidebar, 30);\n  }\n\n  .rt2-shell--locked {\n    grid-template-columns: var(--rt-sidebar-w) minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 1200px) {\n  .rt2-metrics {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .rt2-overview-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 1024px) {\n  .rt2-shell,\n  .rt2-shell--collapsed,\n  .rt2-shell--expanded {\n    grid-template-columns: 1fr;\n  }\n\n  .rt2-sidebar-slot {\n    position: fixed;\n    top: var(--rt-topbar-h);\n    left: 0;\n    bottom: 0;\n    width: var(--rt-sidebar-w);\n    transform: translateX(-100%);\n    transition: transform 180ms ease;\n    z-index: 50;\n    box-shadow: var(--shadow-lg);\n  }\n\n  .rt2-sidebar-slot--open {\n    transform: translateX(0);\n  }\n\n  .rt2-sidebar-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    border: none;\n    background: var(--modal-backdrop);\n    z-index: 45;\n    cursor: pointer;\n  }\n\n  .rt2-sidebar {\n    width: var(--rt-sidebar-w) !important;\n  }\n\n  .rt2-main {\n    grid-column: 1;\n  }\n\n  .rt2-topbar__search span,\n  .rt2-topbar__search kbd {\n    display: none;\n  }\n\n  .rt2-metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 900px) {\n  .rt2-metrics {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .rt2-overview-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt2-shell,\n  .rt2-nav-item,\n  .rt-btn,\n  .rt2-sidebar-slot {\n    transition: none;\n  }\n}\n\n/* ── First-run product tour ─────────────────────────────── */\n.rt-tour {\n  position: fixed;\n  inset: 0;\n  z-index: calc(var(--z-toast, 1400) + 20);\n  pointer-events: none;\n}\n\n.rt-tour__scrim {\n  position: absolute;\n  inset: 0;\n  pointer-events: auto;\n  background: transparent;\n}\n\n.rt-tour__scrim--full {\n  background: rgba(2, 6, 23, 0.55);\n  backdrop-filter: blur(2px);\n  animation: rt-tour-fade var(--duration-normal, 200ms) var(--ease-out, ease-out);\n}\n\n.rt-tour__spot {\n  position: fixed;\n  border-radius: var(--rt-radius-md, 10px);\n  box-shadow:\n    0 0 0 2px var(--rt-primary),\n    0 0 0 6px color-mix(in srgb, var(--rt-primary) 28%, transparent),\n    0 0 0 9999px rgba(2, 6, 23, 0.55);\n  transition:\n    top var(--duration-slow, 280ms) var(--ease-out, ease-out),\n    left var(--duration-slow, 280ms) var(--ease-out, ease-out),\n    width var(--duration-slow, 280ms) var(--ease-out, ease-out),\n    height var(--duration-slow, 280ms) var(--ease-out, ease-out);\n  pointer-events: none;\n}\n\n.rt-tour__card {\n  position: fixed;\n  width: min(340px, calc(100vw - 24px));\n  padding: 18px 18px 14px;\n  border-radius: var(--radius-xl, 12px);\n  border: 1px solid var(--rt-border);\n  background: var(--surface-elevated, var(--rt-surface));\n  color: var(--rt-text);\n  box-shadow: var(--shadow-lg);\n  pointer-events: auto;\n  animation: rt-tour-pop var(--duration-normal, 200ms) var(--ease-out, ease-out);\n}\n\n.rt-tour__card--hero {\n  width: min(420px, calc(100vw - 24px));\n  padding: 28px 26px 18px;\n  text-align: center;\n}\n\n.rt-tour__close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: var(--rt-radius-sm, 6px);\n  background: transparent;\n  color: var(--rt-text-muted);\n  cursor: pointer;\n}\n\n.rt-tour__close:hover {\n  background: var(--rt-bg);\n  color: var(--rt-text);\n}\n\n.rt-tour__badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 12px;\n  border-radius: 12px;\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n}\n\n.rt-tour__badge--done {\n  background: color-mix(in srgb, var(--success, #16a34a) 16%, transparent);\n  color: var(--success, #16a34a);\n}\n\n.rt-tour__eyebrow {\n  margin-bottom: 6px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-primary);\n}\n\n.rt-tour__title {\n  margin: 0 28px 6px 0;\n  font-size: var(--type-section-title, 16px);\n  font-weight: 650;\n  line-height: 1.35;\n  color: var(--rt-text);\n}\n\n.rt-tour__card--hero .rt-tour__title {\n  margin: 0 0 8px;\n  font-size: 19px;\n}\n\n.rt-tour__body {\n  margin: 0;\n  font-size: var(--type-body, 14px);\n  line-height: 1.55;\n  color: var(--rt-text-muted);\n}\n\n.rt-tour__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.rt-tour__card--hero .rt-tour__footer {\n  justify-content: center;\n  margin-top: 22px;\n}\n\n.rt-tour__card--hero .rt-tour__footer > span:empty {\n  display: none;\n}\n\n.rt-tour__actions {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.rt-tour__actions .rt-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rt-tour__dots {\n  display: inline-flex;\n  gap: 5px;\n}\n\n.rt-tour__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--rt-border);\n  transition: width var(--duration-normal, 200ms) var(--ease-out, ease-out), background var(--duration-normal, 200ms);\n}\n\n.rt-tour__dot--active {\n  width: 16px;\n  background: var(--rt-primary);\n}\n\n@keyframes rt-tour-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes rt-tour-pop {\n  from { opacity: 0; transform: translateY(4px) scale(0.98); }\n  to { opacity: 1; transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-tour__spot,\n  .rt-tour__dot { transition: none; }\n  .rt-tour__card,\n  .rt-tour__scrim--full { animation: none; }\n}\n\n.rt-tour__card--list {\n  width: min(372px, calc(100vw - 24px));\n}\n\n.rt-tour__list {\n  display: grid;\n  gap: 8px;\n  margin: 2px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.rt-tour__list li {\n  display: grid;\n  gap: 1px;\n  padding: 7px 10px;\n  border-radius: var(--rt-radius-sm, 6px);\n  background: var(--rt-bg);\n  border: 1px solid var(--rt-border);\n}\n\n.rt-tour__list strong {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--rt-text);\n}\n\n.rt-tour__list span {\n  font-size: var(--type-supporting, 12.5px);\n  line-height: 1.45;\n  color: var(--rt-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
